export default __webpack_public_path__ + "images/b01983a911ba008b9e823d1d19b39f72.png";